import _ from 'lodash';
import React, { useMemo } from 'react';
import {
  CompanySpendTierFilter,
  CompanyTypeFilter,
  IndustryFilter,
  MemberFilter,
  PracticeFilter,
  SingleSelectFilter,
} from '~/components';
import useFeatures from '~/hooks/useFeatures.js';

function CompanyFiltersBar({ filters, sticky, onChange }) {
  const features = useFeatures();

  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      companyOwners: isVisible('companyOwners'),
      companyIsActive: isVisible('companyIsActive'),
      companyIndustries: isVisible('companyIndustries'),
      companyPractices: features.practices && isVisible('companyPractices'),
      companyTypes: isVisible('companyTypes'),
      companySpendTiers: isVisible('companySpendTiers'),
    };
  }, [filters, sticky, features]);

  return (
    <>
      {visible.companyOwners && (
        <MemberFilter
          name="companyOwners"
          placeholder="Company Relationship Owner"
          value={filters.companyOwners}
          onChange={({ target: { value } }) => onChange({ companyOwners: value })}
        />
      )}

      {visible.companyIsActive && (
        <SingleSelectFilter
          icon="filter"
          name="companyIsActive"
          placeholder="Status"
          options={[
            { id: 'true', name: 'Active' },
            { id: 'false', name: 'Inactive' },
          ]}
          value={filters.companyIsActive}
          renderValue={(value) => value.name}
          onChange={({ target: { value } }) => onChange({ companyIsActive: value })}
        />
      )}

      {visible.companyIndustries && (
        <IndustryFilter
          name="companyIndustries"
          placeholder="Company Industry"
          value={filters.companyIndustries}
          onChange={({ target: { value } }) => onChange({ companyIndustries: value })}
        />
      )}

      {visible.companyPractices && (
        <PracticeFilter
          name="companyPractices"
          placeholder="Company Practice"
          value={filters.companyPractices}
          onChange={({ target: { value } }) => onChange({ companyPractices: value })}
        />
      )}

      {visible.companyTypes && (
        <CompanyTypeFilter
          name="companyTypes"
          value={filters.companyTypes}
          onChange={({ target: { value } }) => onChange({ companyTypes: value })}
        />
      )}

      {visible.companySpendTiers && (
        <CompanySpendTierFilter
          name="companySpendTiers"
          value={filters.companySpendTiers}
          onChange={({ target: { value } }) => onChange({ companySpendTiers: value })}
        />
      )}
    </>
  );
}

export default CompanyFiltersBar;
